import { render, staticRenderFns } from "./EscalaCustomer.vue?vue&type=template&id=3d50e27c"
import script from "./EscalaCustomer.vue?vue&type=script&lang=js"
export * from "./EscalaCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports